import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Handles moderation actions (accept, reject, ban, dubious) via fetch + Turbo Streams.
//
// Usage on links:
//   = link_to 'Aceptar', path, data: { controller: 'moderation', action: 'click->moderation#perform',
//     moderation_accion_value: 'aceptar' }
//
// Usage on forms (rechazar):
//   = form_with url: path, data: { controller: 'moderation', action: 'submit->moderation#submitForm',
//     moderation_accion_value: 'rechazar' } do |f|
export default class extends Controller {
  static values = { confirm: String, accion: String }

  perform (event) {
    event.preventDefault()

    if (this.hasConfirmValue && this.confirmValue) {
      if (!window.confirm(this.confirmValue)) return
    }

    const url = this.element.getAttribute('href')
    this._fetch(url)
  }

  submitForm (event) {
    event.preventDefault()

    const form = this.element
    const url = `${form.action}?${new URLSearchParams(new FormData(form)).toString()}`
    this._fetch(url)
  }

  _fetch (url) {
    const row = this.element.closest('tr')
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': csrfToken,
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.text()
      })
      .then(html => {
        if (html.trimStart().startsWith('<turbo-stream')) {
          Turbo.renderStreamMessage(html)
        } else if (html.trim() === '') {
          if (row) this._fadeAndRemove(row)
        } else {
          window.location.reload()
        }
      })
      .catch(err => {
        console.error('[moderation]', err)
        alert('Error al procesar la acción de moderación')
      })
  }

  _fadeAndRemove (element) {
    element.style.transition = 'opacity 0.5s'
    element.style.opacity = '0'
    element.addEventListener('transitionend', () => element.remove(), { once: true })
  }
}
